import type { GetAllOptions } from "../../../server/supabase/base-supabase-service";
import type { SurveyStatus } from "../server/supabase-survey-service";
import type { UseSurveyConfig } from "./types";

export function buildStatusFilter<T extends { status: SurveyStatus["status"] }>(
  allowedStatuses: UseSurveyConfig["allowedStatuses"],
): NonNullable<GetAllOptions<T>["filter"]>[number] | undefined {
  if (!allowedStatuses || allowedStatuses.length === 0) return undefined;

  return {
    key: "status",
    operator: "in",
    value: `(${allowedStatuses.join(",")})`,
  };
}
